module.exports = __webpack_public_path__ + "media/images/checkin-827980b4c6b7d87654eb60a21833b0e2.svg";